// extracted by mini-css-extract-plugin
module.exports = {"page":"case_study_page__Qkd1Y","container":"case_study_container__5bbWb"};